module.exports = __webpack_public_path__ + "img/yiruntong0.71ba0067.svg";